import { useEffect, useRef } from 'react';
const useIsElementVisible = (
  onElementVisible: () => void,
  trigger: any[] = [],
  onElementInvisible?: any,
  isReobserve: boolean = false,
  rootMargin?: any,
  threshold?: number
) => {
  const componentRef = useRef(null);
  useEffect(() => {
    let options: any = {
      threshold: threshold || 0.001,
    };
    if (rootMargin != null) {
      options.rootMargin = rootMargin;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && entry.intersectionRatio >= options.threshold) {
          onElementVisible();
          !isReobserve && observer.disconnect();
        } else {
          onElementInvisible && onElementInvisible();
        }
      });
    }, options);

    if (componentRef.current) {
      observer.observe(componentRef.current);
    }

    return () => {
      if (componentRef.current) {
        observer.unobserve(componentRef.current);
      }
    };
  }, [...trigger]);
  return componentRef;
};
export default useIsElementVisible;
